/**
 * Created by Kenetto® on 18/07/17.
 */
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { getImage } from './DataImages'

const CANVAS_STYLE = {
  border: 'none'
}
const CANVAS_WIDTH = 375
const CANVAS_HEIGHT = 650
const IMAGE_SIZE = 64
const STATE = {
  NORMAL: 'normal',
  TREATED: 'treated',
  LOST: 'lost',
  CARIED: 'caried',
  getAppropriateState: (name = '') => {
    switch (name) {
      case STATE.TREATED:
        return STATE.TREATED
      case STATE.LOST:
        return STATE.LOST
      case STATE.CARIED:
        return STATE.CARIED
      default:
        return STATE.NORMAL
    }
  }
}

export default class TeethViewer extends Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  /**
   * This method is used to draw the initial teeth received in props and bind the canvas events.
   */
  componentDidMount () {
    this.hydrateTeeth(this.props.teeth)
    this.refs.canvas.onmousedown = this.onClick.bind(this)
  }

  hydrateTeeth () {
    const promiseArray = []
    const {teeth, logger} = this.props
    for (const tooth of teeth) {
      promiseArray.push(getImage(`${tooth.id}_${tooth.state}`, logger)
        .then(image => {
          return {
            id: tooth.id,
            position: {x: tooth.position.x, y: tooth.position.y},
            state: tooth.state,
            image: image,
            center: undefined
          }
        }))
    }
    Promise.all(promiseArray)
      .then(teeth => {
        this.drawTeeth(teeth)
        this.setState({teeth: teeth})
      })
  }

  componentWillUpdate (nextProps, nextState) {
    if (nextProps.teeth !== this.props.teeth) {
      this.hydrateTeeth(nextProps.teeth)
    }
  }

  /**
   * Converts an event x and y position to values in the canvas.
   * @param canvas The canvas instance where we want to check the position.
   * @param clientX {Number} The x position of the event.
   * @param clientY {Number} The y position of the event.
   * @return {{canvasX: number, canvasY: number}}
   */
  getCanvasPos (canvas, {clientX, clientY}) {
    const {left, top, width, height} = canvas.getBoundingClientRect()
    const canvasX = Math.round((clientX - left) * (canvas.width / width))
    const canvasY = Math.round((clientY - top) * (canvas.height / height))
    return {canvasX, canvasY}
  }

  /**
   * Checks if the specified position argument is inside a circumference defined by center and radius arguments.
   * @param center {{x, y}} An object containing the x and y center values.
   * @param pos {{x, y}} An object containing the x and y values of the position to check.
   * @param radius {Number} The value of the radius.
   * @return {boolean} True if the specified position is inside the circumference defined by the center and radius arguments.
   */
  checkInside (center, pos, radius) {
    return Math.pow((pos.x - center.x), 2) + Math.pow(pos.y - center.y, 2) <= Math.pow(radius, 2)
  }

  /**
   * The onClick handler.
   * @param event {Event}
   */
  onClick (event) {
    const initTime = window.performance.now()
    event.preventDefault()
    const {logger} = this.props
    const {teeth} = this.state
    const {canvasX, canvasY} = this.getCanvasPos(this.refs.canvas, event)
    for (const tooth of teeth) {
      const {center, radius} = tooth
      if (this.checkInside(center, {x: canvasX, y: canvasY}, radius)) {
        const onClickTime = window.performance.now()
        this.props.onclick({id: tooth.id, currentState: tooth.state})
          .then(({id, nextState}) => {
            if (nextState !== tooth.state) {
              getImage(`${id}_${nextState}`, logger)
                .then(newImage => {
                  tooth.image = newImage
                  tooth.state = nextState
                  this.drawTeeth([tooth])
                })
            }
            logger && logger.log(`TeethViewer::onClick (event) callback execution time ${(window.performance.now() - onClickTime).toFixed(4)} milliseconds`)
          })
        break
      }
    }
    logger && logger.log(`TeethViewer::onClick (event) execution time ${(window.performance.now() - initTime).toFixed(4)} milliseconds`)
  }

  /**
   *
   * @param teeth {[]<{image, position, center, radius}>} The teeth that require drawing.
   */
  drawTeeth (teeth = []) {
    const {logger} = this.props
    const initTime = window.performance.now()
    for (const tooth of teeth) {
      this.drawTooth(tooth, IMAGE_SIZE, IMAGE_SIZE)
    }
    logger && logger.log(`TeethViewer::drawTeeth (teeth) execution time ${(window.performance.now() - initTime).toFixed(4)} milliseconds`)
  }

  /**
   *
   * @param tooth {{image, position, center, radius}} The tooth to draw.
   * @param w {Number} The width the tooth should have.
   * @param h {Number} The height the tooth should have.
   */
  drawTooth (tooth, w, h) {
    const {logger} = this.props
    const initTime = window.performance.now()
    const ctx = this.refs.canvas.getContext('2d')
    const {image, position} = tooth
    tooth.center = {x: position.x + (w / 2), y: position.y + (h / 2)}
    tooth.radius = 0.25 * w
    ctx.drawImage(image, position.x, position.y, w, h)
    logger && logger.log(`TeethViewer::drawTooth (tooth) execution time ${(window.performance.now() - initTime).toFixed(4)} milliseconds`)
  }

  render () {
    return <div>
      <canvas style={CANVAS_STYLE} id='canvas' ref='canvas' height={CANVAS_HEIGHT} width={CANVAS_WIDTH} />
    </div>
  }
}

TeethViewer.propTypes = {
  teeth: PropTypes.array.isRequired,
  onclick: PropTypes.func.isRequired,
  logger: PropTypes.object
}

export { IMAGE_SIZE, STATE, CANVAS_WIDTH, CANVAS_HEIGHT }



// WEBPACK FOOTER //
// ./src/components/general/TeethView/TeethViewer.js